<template>
  <div id="app">
    <Header />
    <router-view/>

    <FramePage v-if="false"  />
  </div>
</template>


<script>
    import Header from '@/components/Header.vue'
    import {mapActions, mapMutations, mapState} from 'vuex'
    import FramePage from "./components/Page/FramePage";

    export default {
        name: "App",
        components: {
            FramePage,
            Header
        },
    }
</script>

<style lang="scss">
  @import "style/base";

  :root {
    --size: 100%;
  }


  html, body {
    margin: 0;
    padding: 0;
    min-height: 100%;
    height: 100%;
    width: 100%;
    font-family: Roboto;
    font-size: 14px;
    color: #888888;
    min-width: 400px;
  }

  body {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  #app {
    position: relative;
  }

  .title {
    font-family: Montserrat;
    color: #000000;
  }

  a {
    text-decoration: none !important;
  }

  .dvBoton {
    @include botonDefault;
  }

  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes outFade {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

</style>
